export const SET_SPQ_QUEUE_ITEM = 'SET_SPQ_QUEUE_ITEM';
export const CLEAN_SPQ_QUEUE_ITEM = 'CLEAN_SPQ_QUEUE_ITEM';
